import { useCallback, useState } from 'react';
import { getPresignedS3UrlDownload } from '../config';
import useRequestCallback from './useRequestCallback';

export function usePreSignedUrlDownloadCallback() {
  const [url, setUrl] = useState(null);
  const {
    callback,
    loading,
    requestInstance
  } = useRequestCallback(
    useCallback(async (request, { file }) => {
      const { configuration } = await request.exec(getPresignedS3UrlDownload({ file }));
      setUrl(configuration);
      return configuration;
    }, [])
  );
  return {
    url,
    callback,
    loading,
    requestInstance
  };
}

export default usePreSignedUrlDownloadCallback;
